import React from 'react';
import {AsyncComponent} from "../../../core/components/router/async-component";
import {LoadingIndicator} from "../../../core/components/loading/loading-indicator";
import classNames from 'classnames';
import styles from '../styles/squad-widget.module.scss';

const SquadWidgetAsyncComponent = AsyncComponent(async () => import('./squad-widget' /* webpackChunkName: "squad-widget" */ ));

export const SquadWidgetAsync = (props) => {
  return <React.Suspense fallback={<div className={classNames(styles.placeholder)}><LoadingIndicator/></div>}>
    <SquadWidgetAsyncComponent {...props}/>
  </React.Suspense>
};
